import { SelectionListServant } from './../../global/servants/selection_list_servant';

export interface IChecklistCapability {
  checklistUrl: string;
}

export class ChecklistConfiguration {
  private ngSelectionListServant: SelectionListServant;

  private _capability: IChecklistCapability = {
    checklistUrl: ''
  };

  constructor() {}

  configureCapability(capability: Partial<IChecklistCapability>) {
    this._capability.checklistUrl = capability.checklistUrl || this._capability.checklistUrl;
    return this;
  }

  get capability() {
    return this._capability;
  }

  $get(ngSelectionListServant: SelectionListServant, $q: ng.IQService) {
    this.ngSelectionListServant = ngSelectionListServant;
    return this;
  }
}

angular.module('capability-ng-checklist').provider('ngChecklistConfiguration', ChecklistConfiguration);



// WEBPACK FOOTER //
// ./app/lib/checklist/config/checklist_configuration.ts